import app from '@/app';

/* @ngInject */
function Urci($resource) {
	return $resource(
		'api/urcis/:id',
		{ id: '@id' },
		{
			query: { method: 'GET' },
			purge: { method: 'DELETE' }
		}
	);
}

app.factory('Urci', Urci);
